export default class popup {
  init (){
    this.popupImg();
  }
  popupImg(){
    $('.js-popup-img').modaal({
      type:'image'
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/popup.js